export default {
    namespaced: true,
    state: {
        //language switcher or user account dropdown
        openedDropdown: null
    },
    mutations: {
        openDropdown(state, value) {   
            if(state.openedDropdown == value) {
                state.openedDropdown = null;
            } else {      
                state.openedDropdown = value;
            }
        },
        closeDropdown(state) {
            state.openedDropdown = null;
        }
    },
    actions: {
        mutateOpenDropdown({commit}, val) {
            commit('openDropdown', val);
        },
        mutateCloseDropdown({commit}) {
            commit('closeDropdown');
        }
    },
    getters: {
        getOpenedDropdown({openedDropdown}) {
            return openedDropdown;
        }
    }
}
